<template>
    <div>
        <table v-if="coupons && coupons.list.length > 0">
            <tr class="th">
                <td v-if="isFromOrder"></td>
                <td>名称</td>
                <td>抵扣金额</td>
                <td>有效期</td>
            </tr>
            <tbody>
                <tr v-for="(item, index) in coupons.list" :key="index">
                    <td v-if="isFromOrder" class="radio">
                        <el-radio v-model="currentCoupon" :label="item.id"></el-radio>
                    </td>
                    <td>{{item.couponName}}</td>
                    <td>{{item.faceValue}}</td>
                    <td>{{item.effectiveStartTime}}至{{item.effectiveEndTime}}</td>
                </tr>
                <tr>
                    <td v-if="isFromOrder" class="radio">
                        <el-radio v-model="currentCoupon" :label="null"></el-radio>
                    </td>
                    <td>不使用优惠券</td>
                </tr>
            </tbody>
        </table>
        <div
            class="table-empty"
            v-if="!coupons || !coupons.list || (coupons.list && coupons.list.length === 0)"
        >
            <i class="el-icon-document-copy"></i>
            <p>暂无数据</p>
        </div>
        <div>
            <div class="mar pageDiv" style="text-align:center">
                <el-pagination
                    v-if="coupons && coupons.list.length > 0"
                    background
                    layout="prev, pager, next,total"
                    :total="coupons.count"
                    :page-size="coupons.pageSize"
                    :current-page="coupons.page"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import * as apis from '../../fetch/user';

export default {
    name: 'Coupon',
    props: ['from', 'orderAmount'],
    data() {
        return {
            coupons: null,
            currentCoupon: null,
        };
    },
    computed: {
        isFromOrder() {
            return this.from === 'order';
        },
    },
    methods: {
        handleCurrentChange(page) {
            this.getCoupon(page);
        },
        getCoupon(page = 1) {
            apis.getCoupon({ couponStatus: 1, page, orderAmount: this.orderAmount }).then(res => {
                this.coupons = res;
            });
        },
    },
    mounted() {
        this.getCoupon();
    },
};
</script>


<style scoped lang="less">
.radio label {
    width: 20px;
    height: 100%;
    overflow: hidden;
}
</style>